import * as React from 'react'
import { LogLevel, LogPointsConnectorsState } from '../model'
import ListPanel from '@mulesoft/anypoint-components/lib/List'
import LogPointsConnectorsItem from '../LogPointsConnectorItem/LogPointsConnectorsItem'
import './LogPointsConnectorsList.css'

export type ValueProps = {
  logPointsConnectors: LogPointsConnectorsState
  logLevelOptions: LogLevel[]
  mainNote?: string
}

export type EventProps = {
  onLogLevelChange: (connectorId: string, logLevel: LogLevel) => void
  onCheckboxChange: (connectorId: string, checked: boolean) => void
}

export type Props = ValueProps & EventProps

const getConnectorsItems = (props: Props) => {
  const {logPointsConnectors} = props
  const connectorsKeys = Object.keys(logPointsConnectors).sort((aKey, bKey) => {
    if (logPointsConnectors[aKey].initialChecked && !logPointsConnectors[bKey].initialChecked) return -1
    if (!logPointsConnectors[aKey].initialChecked && logPointsConnectors[bKey].initialChecked) return 1
    return 0;
  })

  return connectorsKeys.map((connectorKey, index: number) => (
    <LogPointsConnectorsItem
      key={logPointsConnectors[connectorKey].connector.id + '-' + (index + 1)}
      itemKey={logPointsConnectors[connectorKey].connector.id}
      logPointsConnector={logPointsConnectors[connectorKey]}
      onLogLevelChange={props.onLogLevelChange}
      onCheckboxChange={props.onCheckboxChange}
      logLevelOptions={props.logLevelOptions}
    />
  ))
}

const LogPointsConnectorsList = (props: Props) => {
  const items = getConnectorsItems(props)

  return (
    <div className="log-points-connectors-container" data-test-id="log-points-connectors-container">
      <div className="log-points-connectors-notes">
        { props.mainNote &&
          <span className="log-points-connectors-main-note" data-test-id="log-points-connectors-main-note">{props.mainNote}</span>
        }
        <span className="log-points-connectors-note" data-test-id="log-points-connectors-note">
          Disable the Log Points when you are done, as it may affect your application performance.
        </span>
      </div>

      <div className="log-points-connectors" data-test-id="log-points-connectors">
        <ListPanel items={items}/>
      </div>
    </div>
  )
}

export default LogPointsConnectorsList
